// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const fbs = {
  fbs_tokens: {
    exam: '检查',
    frame: '镜架',
    cancer: '癌症(内部或侵袭性)',
    crowns: '牙冠',
    frames: '镜架',
    inlays: '嵌体',
    lenses: '镜片',
    spouse: '配偶保障金额',
    stroke: '中风',
    '180-days': '180天',
    children: '子女保障金额',
    contacts: '隐形眼镜(代替眼镜)',
    fillings: '补牙',
    materials: '材料',
    '50_percent': '承保50%',
    '80_percent': '承保80%',
    'exam-copay': '检查共付额',
    individual: '个人保障金额',
    '100_percent': '承保100%',
    Orthodontia: '正畸',
    'add-maximum': '意外死亡和伤残最高限额',
    orthodontia: '正畸',
    purple_coma: '昏迷',
    purple_none: '无',
    'skin-cancer': '皮肤癌',
    'std-14-days': '意外14天;疾病14天',
    '1000_dollars': '$1,000',
    'dental-xrays': '牙科X光',
    'heart-attack': '心脏病发作(心肌梗塞)',
    'lenses-copay': '镜片共付额',
    'life-maximum': '人寿保险最高限额',
    'oral-surgery': '口腔手术',
    'admission-icu': '入院(ICU)',
    'ambulance-air': '救护车 - 空中',
    'child-maximum': '子女最高限额',
    exam_services: '检查服务',
    'lasik-surgery': '激光手术',
    'ncoa-medicare':
      '考虑退休、即将年满65岁,或为亲人寻找信息?现在开始了解医疗保险注册,并获得免费的个性化医疗保险建议。',
    purple_frames: '眼镜 - 镜架',
    purple_lenses: '眼镜 - 镜片',
    '1-times-salary': '1倍工资',
    '2-times-salary': '2倍工资',
    '5_dollar_copay': '$5共付额',
    basic_services: '基本修复护理',
    'contact-lenses': '隐形眼镜',
    contact_lenses: '隐形眼镜',
    'intensive-care': '重症监护',
    major_services: '主要修复护理',
    purple_14_days: '14天',
    'spouse-maximum': '配偶最高限额',
    '10_dollar_copay': '$10共付额',
    '20_dollar_copay': '$20共付额',
    'add-description':
      '意外死亡和伤残(AD&D)保险在您发生承保的意外身体伤害并直接导致伤残(即失去手、脚或眼睛)时,向您提供指定的福利。如果您因承保的意外事故去世,将支付AD&D福利。',
    'confinement-icu': '住院(ICU)',
    'eap-description':
      '生活充满挑战,有时平衡生活很困难。Harbor Freight Tools自豪地通过Cigna提供一项保密计划,致力于支持您和您家人的情绪健康和福祉。',
    'hsa-description':
      'Harbor Freight Tools将向您的HSA提供以下年度供款:如果您每月两次至少贡献$5自己的资金,Harbor Freight Tools将为仅员工保障提供$500的年度供款,或为有登记受抚养人的员工提供$1,000。如果您决定不贡献任何自己的资金,Harbor Freight Tools将为仅员工保障提供$250的年度供款,或为有登记受抚养人的员工提供$500。',
    'inpatient-rehab': '住院康复',
    'ltd-description':
      '如果您因生病或受伤而无法工作,伤残保险福利可能会提供收入来支持您,以便您可以专注于康复,而不是担心如何支付账单。这些福利与可用的州伤残计划相协调。',
    'pet-description':
      '您希望为您的宠物提供最好的照顾。虽然很难预测意外和疾病,但Pets Best宠物保险让您更容易为它们做好准备。作为Harbor Freight Tools的员工,您有资格获得Pets Best宠物保险的折扣。保费根据您宠物的年龄、种类、体型(成年时)、计划类型、免赔额和居住州而有所不同。',
    purple_180_days: '180天',
    purple_24_weeks: '24周',
    purple_wellness: '健康福利',
    standard_lenses: '标准塑料镜片',
    'std-description': '',
    'wellvision-exam': 'WellVision检查',
    '401k-description':
      '为了帮助您为梦想的退休生活储蓄,我们提供由Wells Fargo管理的401(k)储蓄计划。您可以通过税前或Roth税后工资扣除向您的账户供款。您的供款不得超过IRS年度限额$19,500。如果您年满50岁或以上,您可以额外进行"追补"供款,最高$6,500。Harbor Freight Tools将匹配您供款的前3%的100%,加上接下来2%的50%',
    'ambulance-ground': '救护车 - 地面',
    covered_by_copay: '由共付额承保',
    'employee-maximum': '员工最高限额',
    'health-screening': '健康筛查',
    'life-description':
      '人寿保险在您去世时向您指定的受益人提供经济福利。如果您因承保的意外事故去世,将支付人寿保险福利。',
    'oral-examination': '口腔检查共付额/共同保险',
    purple_ambulance: '救护车(地面/空中)',
    'up-to-60-dollars': '最高$60',
    '1000-lifetime-max': '19岁以下儿童终身最高限额$1,000。不承保成人正畸',
    '500-per-admission': '每次入院$500',
    'admission-non-icu': '入院(非ICU)',
    'basic-restoration': '基本修复',
    'carcinoma-in-situ': '原位癌',
    'frames-and-lenses': '镜架',
    'legal-description':
      '成功的沟通计划可以提高员工对您的法律保险计划的认识和理解。ARAG帮助您在适当的时间将正确的沟通工具整合到您现有的沟通渠道中,并提供新的方式来增强您的计划。',
    'major-restoration': '主要修复',
    'prophylaxis-adult': '预防性治疗 - 成人',
    'prophylaxis-child': '预防性治疗 - 儿童',
    purple_50_percent: '计划支付承保服务的50%',
    purple_80_percent: '计划支付承保服务的80%',
    purple_concussion: '脑震荡',
    purple_increments: '增量',
    '1000-per-admission': '每次入院1,000',
    'add-benefit-amount': 'AD&D福利金额',
    'deductible-then-50': '免赔额后50%',
    'deductible-then-80': '免赔额后80%',
    'deductible-then-90': '免赔额后90%',
    purple_100_percent: '计划支付承保服务的100%',
    purple_orthodontia: '正畸',
    purple_vision_exam: '常规视力检查',
    'xray-and-emergency': 'X光和急诊室服务',
    'confinement-non-icu': '住院(非ICU)',
    'exclusions-ci1-demo':
      '该计划包含30天的等待期。这意味着在您的保障从生效日期起生效30天之前被诊断的任何人都不支付福利。如果您在等待期内首次被诊断,该重大疾病的治疗福利将仅适用于从生效日期起12个月后开始的损失,或员工可以选择取消保障并获得全额保费退款。如果满足以下条件,将支付适用的福利金额:诊断日期在等待期之后;诊断日期发生在证书有效期内;疾病原因未被名称或具体描述排除。',
    'exclusions-hi1-demo':
      '该保单或其条款可能在某些州有所不同或不可用。医院疾病福利有既往病症限制。MetLife的医院赔偿保险可能会在65岁时开始减少福利。与大多数团体意外和健康保险保单一样,MetLife提供的保单可能包含某些排除条款、限制和保持有效的条款。有关保障和可用性的完整详情,请参阅团体保单表格GPNP12-AX或GPNP13-HI或联系MetLife。福利由Metropolitan Life Insurance Company承保,纽约,纽约。',
    'life-benefit-amount': '人寿保险福利金额',
    '180_dollar_allowance': '$180津贴',
    '200-dollar-allowance': '$200津贴',
    '50-per-calender-year': '每日历年$50',
    'accident-description':
      '意外保险为您在不工作时发生的承保意外事故导致的特定伤害和事件支付福利,该事故发生在您的保障生效日期当日或之后。福利金额取决于伤害类型和接受的护理。您的雇主免费为您提供意外保险。您还可以选择额外的保障以满足您的需求。意外保险是一项有限福利保单。它不是健康保险,不满足《平价医疗法案》下的最低基本保障要求。',
    'child-benefit-amount': '子女福利金额',
    'commuter-description':
      '通勤福利计划让您通过税前工资扣除支付合格的与工作相关的交通费用,从而节省通勤费用。2022年,您可以供款:每月最高$270用于支付合格的停车费用,每月最高$270用于支付合格的交通费用。',
    'description-add-demo':
      '您可以以$25,000的增量选择自愿AD&D保障。您可以选择的最低金额为$25,000。最高金额为$500,000或您年收入的10倍中的较小者,如果不是$25,000的倍数,则向下舍入到下一个较低的$25,000的倍数。',
    'description-eap-demo':
      '员工援助计划(EAP)是一项旨在帮助员工解决可能影响工作表现的与心理和情绪健康相关的各种问题的福利。',
    'description-hra-demo':
      '您的雇主向您的HRA存入$1,050,您在计划年度开始时获得全额供款。当您接受承保的医疗服务时,您的账户会自动扣款。',
    'description-pet-demo':
      '您登记的每只宠物都将有单独的保单。如果您登记2-3只宠物,您将有资格获得5%的多保单保费折扣。通过WorkDay访问AlliantCHOICE Plus网站选择宠物保险。',
    'description-std-demo':
      'STD福利将在伤残日期后14天开始支付给伤残员工。在14天的等待期内,必须使用可用的病假和带薪休假(PTO)(按此顺序)。在14天的等待期后,伤残员工将获得相当于基本工资100%的STD付款,最长六(6)周。',
    'exclusions-acc1-demo':
      '以下情况不支付福利:(a)生效日期之前发生的伤害;(b)因工伤事故导致的伤害;(c)任何战争行为或参与暴乱、叛乱或反叛;(d)自我伤害;(e)自杀或自杀未遂;(f)在酒精或麻醉品影响下,除非按照医生的建议服用;(g)细菌感染(除了意外割伤或伤口引起的化脓性感染);(h)参与航空活动,除非是持牌公共承运人飞机上的付费乘客;(i)从事非法职业、袭击或重罪;(j)在任何赛道或高速赛道上驾驶任何比赛或速度测试或测试任何车辆;(k)担任任何国家的陆军、海军或空军的现役成员;以及(l)疝气,包括并发症。',
    'gross-weekly-benefit': '总周福利',
    'hospital-confinement': '医院住院',
    'hospital-description':
      '医院赔偿保险在您在医院*、重症监护室或康复设施承保住院时支付每日福利。福利金额由设施类型和您住院的天数决定。您的雇主免费为您提供医院赔偿保险。您还可以选择额外的保障以满足您的需求。',
    'id-theft-description': '使用PrivacyArmor保护您家人的隐私、身份和财务。',
    'prescription-glasses': '处方眼镜',
    purple_death_benefit: '死亡福利',
    purple_life_required: '需要自愿人寿保险',
    '150-allowance-vision1': '隐形眼镜和隐形眼镜检查(配戴和评估)$150津贴。隐形眼镜检查节省15%。',
    '180-allowance-vision1': '多种镜架选择$180津贴。超出津贴部分节省20%。Costco或Walmart $100津贴。',
    'child-max-description': '$10,000;14天以下$500',
    'description-401k-demo':
      '401K — 您的雇主将匹配您向401(k)计划供款的最高5%的工资。您选择如何投资您的供款和雇主的匹配供款。在此开始:https://nb.fidelity.com/public/nb/default/home',
    'description-403b-demo': '403(b)计划让您在扣除税款之前储蓄和投资部分工资。',
    'description-dis1-demo':
      '您的雇主为您提供100%支付的长期伤残保险。您伤残前收入的前$2,000的50%,每月最高$1,000。最低福利为其他收入福利$100的10%减少前的较大者,以证书中的超额支付和康复激励为准。有关更多信息,请参阅计划详情。',
    'description-hsa1-demo':
      '如果您注册符合HSA资格的计划并开设健康储蓄账户,您的雇主将向您的HSA账户提供以下供款:个人$2,000,家庭$4,000。注意:如果您是新员工,HSA供款将根据年内的雇用日期按比例分配。',
    'description-ltd2-demo':
      '您伤残前收入的前$2,000的50%,每月最高$1,000。最低福利为其他收入福利$100的10%减少前的较大者,以证书中的超额支付和康复激励为准。',
    'description-sihra-hub':
      '如果您注册替代团体医疗计划并放弃HUB保障,健康计划报销计划将报销您承保的自付医疗费用的100%,最高至《平价医疗法案》(ACA)自付限额。这包括您的免赔额、共同保险和共付额,但不包括您的医疗保费。',
    diagnostic_preventive: '预防和诊断',
    'gross-monthly-benefit': '总月福利',
    purple_basic_services: '基本服务、牙髓治疗、牙周治疗、口腔手术',
    purple_major_services: '主要服务、修复、种植',
    purple_spouse_benefit: '配偶福利',
    purple_weekly_benefit: '周福利',
    'spouse-benefit-amount': '配偶福利金额',
    '0_copay_120__allowance': '$0共付额;超出$120津贴部分20%折扣',
    '0_copay_175__allowance': '$0共付额;超出$175津贴部分20%折扣',
    'benefit-waiting-period': '福利等待期',
    'description-legal-demo': '法律计划是雇主提供的补充福利,为员工提供经验丰富的律师网络的访问权限。',
    'description-life1-demo':
      '您的雇主为您提供100%支付的基本定期人寿保险和AD&D保险。意外死亡和伤残(AD&D)保障补充您的基本人寿保险保障,并帮助全天候保护您,一年365天。有关更多信息,请参阅计划详情。',
    'description-life2-demo': '您的雇主为您提供100%支付的基本定期人寿保险。有关更多信息,请参阅完整计划详情。',
    'major-organ-transplant': '主要器官移植',
    purple_10_dollar_copay: '$10共付额',
    purple_eap_description:
      '一种人际联系解决方案,提供主动的情绪和心理健康培训、辅导和24/7支持,以改善生活/工作福祉和生产力。我们将帮助您从源头解决问题,并在文化层面上解决心理健康问题。',
    purple_hsa_description:
      '如果您注册符合HSA资格的计划并开设健康储蓄账户,您的雇主将向您的HSA账户提供以下供款:个人$500,家庭$1,000。注意:如果您是新员工,HSA供款将根据年内的雇用日期按比例分配。',
    purple_monthly_benefit: '月福利',
    purple_orthodontia_max: '正畸最高限额',
    purple_pet_description:
      '我们广受欢迎的My Pet Protection宠物保险计划现在提供更多选择和更大灵活性。从三个报销级别中选择:90%、70%或50%。可选健康保障包括绝育/去势、牙齿清洁、检查、疫苗接种等',
    'spouse-max-description': '$250,000,不超过员工福利的50%',
    '100-a-day-up-to-15-days': '每天$100,每次入院最多15天',
    'critical-illness-spouse':
      '您可以选择$5,000、$10,000或$15,000的配偶重大疾病福利金额。您可以选择最高为您福利金额50%的配偶重大疾病福利。仅在选择员工保障时可用。',
    'dental-dhmo-description': '有关承保福利和共付额的完整列表,请参阅"完整计划详情"。',
    'dislocation-or-fracture': '脱位或骨折',
    'employee-benefit-amount': '员工福利金额',
    'end-stage-renal-failure': '终末期肾衰竭',
    'initial-hospitalization': '初次住院',
    'medical-fsa-description':
      '医疗保健FSA资金可用于支付您、您的配偶、26岁以下的子女以及您在联邦纳税申报表上申报的受抚养人的合格医疗保健费用。合格的医疗保健费用包括:免赔额、共付额和共同保险;处方药;正畸;眼镜和隐形眼镜;激光眼科手术(LASIK)',
    purple_benefit_duration: '福利期限',
    purple_beneft_reduction: '福利减少(减少额)',
    purple_contacts_medical: '隐形眼镜 - 医疗必需的处方镜片',
    purple_employee_benefit: '员工福利',
    calendar_year_deductible: '日历年免赔额',
    'employee-max-description': '4倍工资或$500,000中的较小者',
    'lesser-of-1-times-salary': '1倍工资或$100,000中的较小者',
    'lesser-of-2-times-salary': '2倍工资或$250,000中的较小者',
    'life-and-add-description':
      '人寿保险在您去世时向您指定的受益人提供经济福利。意外死亡和伤残(AD&D)保险在您发生承保的意外身体伤害并直接导致伤残(即失去手、脚或眼睛)时,向您提供指定的福利。如果您因承保的意外事故去世,人寿保险和AD&D福利都将支付。您免费获得基本人寿保险/AD&D。对于小时工,人寿保险福利金额为1倍工资(最高为< 1倍工资或$100,000)。当您首次符合资格时,您保证获得< 1倍工资或$100,000的金额。AD&D福利金额为1倍工资(最高为< 1倍工资或$100,000)。对于受薪员工,人寿保险福利金额为2倍工资(最高为< 2倍工资或$250,000)。当您首次符合资格时,您保证获得< 2倍工资或$250,000的金额。AD&D福利金额为2倍工资(最高为< 2倍工资或$250,000)。',
    orthodontia_lifetime_max: '正畸终身最高限额',
    purple_contacts_elective: '隐形眼镜 - 选择性处方镜片',
    '100-percent-no-deductible': '100%无免赔额',
    '50_percent_coverage_to_19': '19岁前承保50%',
    'child-benefit-description': '$1,000的单位',
    'critical-illness-children':
      '您可以选择$5,000、$10,000或$15,000的子女重大疾病福利金额。您可以选择最高为您福利金额50%的子女重大疾病福利。仅在选择员工保障时可用。',
    'dependent-fsa-description':
      '受抚养人护理FSA为您提供支付受抚养人护理费用(如日托、学前班、残疾受抚养人日托)的机会,以便您(以及您的配偶,如果已婚)可以工作或全日制上学。符合条件的受抚养人包括您13岁以下的子女,以及身体或精神上无法照顾自己且是您税务受抚养人的成年人。',
    'description-commuter-demo':
      '当员工注册通勤福利计划时,他们可以使用税前资金支付通勤费用,最高至当前IRS税收限额每月$270。由于员工通勤方式多样,包括汽车、公共汽车、地铁、火车、渡轮和拼车,员工可以通过多种方式获得福利,以便每个人都能享受。一旦员工注册并提供了通勤信息,他们就可以直接在家中或工作场所收到通勤福利产品',
    'description-life-add-demo':
      '人寿保险和AD&D保险是可以帮助保护您的亲人免受因死亡或严重伤害而造成的经济困难的福利。',
    'description-wellness-demo':
      '健康福利计划旨在帮助改善员工的整体健康和福祉,它们专注于减少疾病和提高生活质量。',
    'diagnostic-and-preventive': '诊断和预防',
    'health-screening-wellness': '健康筛查(健康)',
    'lasik-surgery-description': '常规价格15%折扣或促销价格5%折扣',
    purple_elimination_period: '等待期',
    purple_frames_description: '计划提供$150镜架津贴,之后20%折扣',
    purple_hospital_admission: '医院入院',
    purple_spouse_benefit_add: '$5,000的增量,最高$200,000',
    purple_spouse_non_med_max: '配偶非医疗最高限额',
    '50-percent-weekly-earnings': '您每周承保收入的50%',
    '67-percent-weekly-earnings': '您每周承保收入的67%',
    purple_50_percent_children: '计划为受抚养子女支付承保服务的50%',
    'spouse-benefit-description': '$5,000的单位',
    '100-a-day-for-up-to-31-days': '每天$100,最多31天',
    '200-a-day-for-up-to-31-days': '每天$200,最多31天',
    '50-percent-after-deductible': '免赔额后50%',
    '50-percent-monthly-earnings': '您每月承保收入的50%',
    '50_percent_after_deductible': '免赔额后50%',
    '70-percent-monthly-earnings': '您每月承保收入的70%',
    '80-percent-after-deductible': '免赔额后80%',
    'critical-illness-individual': '您可以选择$10,000、$20,000或$30,000的重大疾病福利金额。',
    'description-fsamedical-demo':
      '在雇用或任命日期的31天内或在您收到正式欢迎信日期的31天内(以较晚者为准),使用ADP注册医疗保健FSA',
    purple_children_benefit_add: '$10,000或$20,000',
    purple_employee_benefit_add: '$500,000或5倍年收入中的较小者',
    purple_employee_non_med_max: '员工非医疗最高限额',
    purple_hospital_confinement: '医院住院',
    purple_id_theft_description:
      'ID Watchdog在您的个人信息被盗时帮助警告您,并在被盗信息被用于非法获利时帮助您更好地保护自己和家人免受身份欺诈。您将更加安心,因为您知道您不必独自面对身份盗窃的复杂性。',
    purple_incremental_increase: '可增量增加',
    purple_wellness_description: 'Hartford计划中无健康福利',
    'accident-physician-treatment': '意外医生治疗',
    'critical-illness-description':
      '重大疾病保险在您于保障生效日期当日或之后被诊断出承保的疾病或状况时支付一次性福利。您可以选择重大疾病保险。',
    'employee-benefit-description': '$10,000的单位',
    'life-guaranteed-issue-amount': '人寿保险保证发行金额',
    'maximum-gross-weekly-benefit': '最高总周福利',
    purple_ambulance_description: '$300 / $900',
    purple_basic_add_description:
      'Purple为每位员工提供$25,000的人寿保险和AD&D保险作为您核心福利的一部分。您配偶的基本人寿保险保障为$5,000,您受抚养子女的基本人寿保险保障为$5,000(6个月以上)和从出生到6个月$1,000。此保障对员工完全免费 — Purple支付保费。此外,如果您退休、失去资格或终止与Purple的雇佣关系,您可以选择转换您的保障。',
    purple_diagnostic_preventive: '诊断和预防服务',
    purple_preexisting_condition: '既往病症条款',
    'child-guaranteed-issue-amount': '子女保证发行金额',
    'description-fsadependant-demo':
      '您可以在雇用或任命日期的31天内或在您收到正式欢迎信的31天内(以较晚者为准)注册受抚养人护理FSA。要开设账户,请访问:https://www.wageworks.com',
    'maximum-gross-monthly-benefit': '最高总月福利',
    purple_accident_disclocations: '脱位和骨折',
    purple_basic_life_description:
      'Purple为每位员工提供$25,000的人寿保险和AD&D保险作为您核心福利的一部分。您配偶的基本人寿保险保障为$5,000,您受抚养子女的基本人寿保险保障为$5,000(6个月以上)和从出生到6个月$1,000。此保障对员工完全免费 — Purple支付保费。此外,如果您退休、失去资格或终止与Purple的雇佣关系,您可以选择转换您的保障。',
    purple_std_elimination_period: '等待期 - 意外/疾病',
    'coronary-artery-bypass-surgery': '冠状动脉搭桥手术',
    purple_medical_fsa_description:
      '一旦您选择,您所有的医疗FSA资金在计划年度的第一天就可以使用。例如,如果您选择向医疗FSA供款$1,200,您的供款将在全年的所有工资中平均扣除,但您在第1天就可以使用全部$1,200!您可以将资金用于您、您的配偶或符合条件的受抚养人产生的费用。',
    'spouse-guaranteed-issue-amount': '配偶保证发行金额',
    'voluntary-life-add-description':
      '人寿保险在您去世时向您指定的受益人提供经济福利。如果您因承保的意外事故去世,将支付人寿保险福利。意外死亡和伤残(AD&D)保险在您发生承保的意外身体伤害并直接导致伤残(即失去手、脚或眼睛)时,向您提供指定的福利。如果您因承保的意外事故去世,将支付AD&D福利。',
    purple_copay_dental_description: '有关承保福利和服务的完整列表,请参阅"完整计划详情"',
    'employee-guaranteed-issue-amount': '员工保证发行金额',
    'included-in-prescription-glasses': '包含在处方眼镜中',
    purple_death_benefit_description: '$30,000员工 / 50%配偶 / 25%子女',
    purple_dependent_fsa_description:
      '受抚养人护理FSA允许您在从工资中向受抚养人护理FSA供款时使用账户中的资金。每次工资供款后,这些资金将应用于您的账户并可用于报销。这与医疗FSA不同,因为您不能在第1天使用所有资金。',
    purple_life_required_description: '否,无论人寿保险保障如何均可购买',
    purple_daily_hospital_confinement: '每日医院住院福利',
    purple_dependent_children_benefit: '受抚养子女福利',
    purple_weekly_benefit_description: '60%,最高$1,500',
    'child-guaranteed-issue-description': '所有金额',
    'contact-lenses-medically-necessary': '隐形眼镜(医疗必需)',
    purple_dependent_child_non_med_max: '受抚养子女非医疗最高限额',
    purple_monthly_benefit_description: '60%,最高$15,000',
    'description-financial-wellness-demo': '财务健康福利包括一系列服务,旨在帮助员工改善其财务状况。',
    purple_contacts_medical_description: '计划支付承保服务的100%',
    'spouse-guaranteed-issue-description': '$50,000',
    purple_benefit_reduction_description: '65岁时减少至65%,70岁时减少至50%',
    purple_contacts_elective_description: '计划提供$150津贴代替眼镜;超出$150津贴的常规隐形眼镜享受15%折扣。',
    purple_dependent_age_coverage_status: '受抚养人年龄保障状态',
    'employee-guaranteed-issue-description': '3倍工资或$250,000中的较小者',
    purple_hospital_confinement_description: '每天$200,最多365天',
    purple_incremental_increase_description: '是,$10,000或更高可在未来注册时增加到GI而无需健康问题',
    purple_accident_disclocations_description: '根据伤害、治疗和服务而有所不同',
    purple_daily_hospital_confinement_description: '每天$150,最多31天',
    purple_dependent_age_coverage_status_description: '14天至26岁(如果是全日制学生则至26岁)',
  },
};
